// Türkçe-locale güvenli metin yardımcıları (13.08: I/i hataları).
//
// Neden: JS'in düz toLowerCase/toUpperCase'i Türkçe'de yanlış sonuç verir:
//   'İSTANBUL'.toLowerCase()          -> 'i̇stanbul' (i + U+0307 combining dot)
//   'i̇stanbul'.includes('istanbul')   -> false  → arama kutuları veriyi bulamaz
//   'IŞIK'.toLowerCase()              -> 'işik' ('ı' değil 'i')
//   'ilçe'.toUpperCase()              -> 'ILÇE' ('İLÇE' olmalı)
// Çözüm: toLocaleLowerCase('tr-TR') / toLocaleUpperCase('tr-TR') + 'tr' localeCompare.

/** Türkçe kurallarla küçük harfe çevirir ('İ'→'i', 'I'→'ı'). */
export const trLower = (s) => String(s ?? '').toLocaleLowerCase('tr-TR');

/** Türkçe kurallarla büyük harfe çevirir ('i'→'İ', 'ı'→'I'). */
export const trUpper = (s) => String(s ?? '').toLocaleUpperCase('tr-TR');

/** Büyük/küçük harf duyarsız (Türkçe) içerme testi — arama filtreleri için. */
export const trIncludes = (haystack, needle) => trLower(haystack).includes(trLower(needle));

/**
 * Arama anahtarı: Türkçe küçük harf + ı/ş/ğ/ü/ö/ç → i/s/g/u/o/c, noktalama boşluk.
 * 'Şişli' ve 'sisli', 'ISTANBUL' ve 'İstanbul' aynı anahtara düşer. Nokta korunur
 * (PYP kodları: 'APK.016.OM001.059').
 */
export const trFold = (s) => trLower(s)
  .replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g')
  .replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c')
  .normalize('NFD').replace(/[̀-ͯ]/g, '') // â, î, û ve 'i̇' gibi artık işaretler
  .replace(/[:(),;/\\"'\-_]+/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

/** Türkçe alfabe sırasına göre karşılaştırma — tablo sıralamaları için. */
export const trCompare = (a, b) => String(a ?? '').localeCompare(String(b ?? ''), 'tr');

/** Büyük/küçük harf duyarsız (Türkçe) eşitlik testi. */
export const trEquals = (a, b) => trLower(a) === trLower(b);

export default trIncludes;
